module.exports = __webpack_public_path__ + "img/main_04.d6d0672b.png";